/** Select / Dropdown popover — see .cursor/docs/design/product-ui-conventions.md Field control groups */
export const fieldSelectPopoverPlacement = "bottom start" as const;

/** Popover width = visually unified field control (outer bordered box), via --trigger-width */
export const fieldSelectPopoverClassName =
  "w-[var(--trigger-width)] max-w-[var(--trigger-width)] min-w-0 p-0";

/**
 * SearchableSelect 下拉壳：与 ListBox item 同用 rounded-2xl；
 * 覆盖 Autocomplete 默认的 min(32px, radius-3xl) 药丸圆角与 pt-2。
 */
export const searchableSelectPopoverClassName =
  `${fieldSelectPopoverClassName} max-h-80 overflow-hidden !rounded-2xl !pt-0`;

/**
 * 下拉内搜索区：四周留白对称（覆盖 Autocomplete 默认 py-1），底部分隔线衔接列表。
 * `!` 用于压过 `.autocomplete__popover [data-slot=search-field]` 的 px-3 py-1。
 */
export const searchableSelectSearchFieldClassName =
  "shrink-0 border-b border-border !px-2.5 !py-2.5";

/** 搜索框圆角与 ListBox.Item（rounded-2xl）对齐。 */
export const searchableSelectSearchGroupClassName =
  "!rounded-2xl shadow-none";

export const fieldSelectMenuLabelClassName =
  "min-w-0 flex-1 whitespace-normal break-words leading-snug";

/**
 * Trigger wraps the whole unified control (value + separator + trailing affix in one border).
 * Popover width then matches what the user sees as one field, not the inner value slice alone.
 */
export const fieldGroupTriggerClassName =
  "flex h-9 w-full min-w-0 items-stretch justify-start overflow-visible rounded-field border border-field-border bg-field text-left shadow-field outline-none transition-[background-color,border-color,box-shadow] hover:bg-field-hover hover:border-field-border-hover data-[pressed=true]:scale-100";

/** Dropdown/Select root — trigger must fill the grid cell so --trigger-width = cell width */
export const fieldControlRootClassName = "w-full min-w-0 max-w-full";
